<div class="modal-header">
    <h4 class="modal-title">Edit Category FAQ</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
    <form>
        {{ filter }} - {{ filterId }}
        <div *ngFor="let i of [0,1,2,3,4]" class="mb-4 border p-3 rounded">
            <h6 class="text-primary mb-3">FAQ {{i + 1}}</h6>

            <!-- Question -->
            <div class="mb-3">
                <label class="form-label fw-bold">Question</label>
                <textarea class="form-control" rows="2" [value]="question[i] || ''"
                    (input)="updateQuestion(i, $event.target.value)" placeholder="Enter question {{i + 1}}"></textarea>
            </div>

            <!-- Answer -->
            <div class="mb-3">
                <label class="form-label fw-bold">Answer</label>
                <textarea class="form-control" rows="3" [value]="answer[i] || ''"
                    (input)="updateAnswer(i, $event.target.value)" placeholder="Enter answer {{i + 1}}"></textarea>
            </div>

            <!-- Attached Product Slug -->
            <div class="mb-3">
                <label class="form-label fw-bold">Attached Product Slug</label>
                <input type="text" class="form-control" [value]="attachedProductSlug[i] || ''"
                    (input)="updateAttachedProductSlug(i, $event.target.value)"
                    placeholder="Enter product slug {{i + 1}}">
            </div>

            <!-- Product Search -->
            <div class="mb-3">
                <label class="form-label fw-bold">Search for Product to Attach</label>
                <input type="text" class="form-control" (keydown)="searchProducts($event.target.value, i + 1)"
                    placeholder="Search for product to attach">
            </div>

            <!-- Product Search Results -->
            <div class="mb-3" *ngIf="getSearchedProducts(i + 1)?.length">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <label class="form-label fw-bold">Search Results</label>
                    <button class="btn btn-sm btn-outline-secondary" (click)="clearSearchedProducts(i + 1)">
                        Clear Products
                    </button>
                </div>
                <div class="products row">
                    <div class="col-6 mb-3" *ngFor="let list of getSearchedProducts(i + 1)">
                        <common-product-card-view [list]="list" (view)="setAttachedProductOfFaq(list?.slug, i + 1)">
                        </common-product-card-view>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveFaq()">Save FAQ</button>
</div>